import {Component, Input, OnInit} from '@angular/core';
import { CardWebRestService } from '../shared/card-web-rest.service';
import { Observable } from 'rxjs';
import { CardWebListElement } from '../shared/CardWebListElement';
import { CardStoreService } from '../shared/card-store.service';
import { DesignGroupPostElement} from '../shared/design-group-post-element';
import {MatDialog} from '@angular/material/dialog';
import {InvitationDialogComponent} from './invitation-dialog/invitation-dialog.component';

@Component({
  selector: 'em-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css'
})

export class DashboardComponent implements OnInit {
  designs$: Observable<CardWebListElement[]>;
  designGroups$: Observable<DesignGroupPostElement[]>;
  options = new Map<number, string>();
  cardDeckId: number;
  sortValue = 2; // CreatedDateTime

  invitationDialogIsOpen = false;

  @Input() timestamp: string; // If there is an invitation to add a new design from another user

  constructor(
      private cs: CardStoreService,
      private cwrs: CardWebRestService,
      private invitationDialog: MatDialog) {

  }

  ngOnInit(): void {
    this.loadDesigns();
    this.loadDesignGroups();
    // Initial emitEvent to refresh design visualizations on dashboard when returning from graphEditor
    this.cwrs.emitDesignInvitationChangeEvent();
    this.cs.getUserLoginListener().subscribe(userObs => {
      if (userObs !== undefined) {
        userObs.subscribe(user => {
          if (user.carddecks) {
            this.cardDeckId = user.carddecks[0].id;
            if (this.timestamp !== null) {
              this.openAcceptInvitationDialog();
            }
          }
        });
      }
    });

    this.designGroups$.subscribe(designGroups => {
      this.options.clear();
      for (const designGroup of designGroups) {
        this.options.set(designGroup.groupId, designGroup.groupName);
      }
    });
  }

  openAcceptInvitationDialog() {
    this.invitationDialogIsOpen = true;
    this.invitationDialog.open(InvitationDialogComponent,
        {
          data: {
            timestamp: this.timestamp,
            cardDeckId: this.cardDeckId
          },
          autoFocus: false
        });
    this.invitationDialog.afterAllClosed.subscribe(result => {
      this.invitationDialogIsOpen = false;
    });
  }

  loadDesigns() {
    this.designs$ = this.cwrs.getDesignsChangeListener();
  }

  processDesignChange($event: Event) {
    this.loadDesignGroups();
    this.cwrs.emitDesignInvitationChangeEvent();
  }

  loadDesignGroups() {
    this.designGroups$ = this.cwrs.getAllDesignGroups();
    this.designGroups$.subscribe(designGroups => {
      this.options.clear();
      for (const designGroup of designGroups) {
        this.options.set(designGroup.groupId, designGroup.groupName);
      }
    });
  }


  getDefaultDesignGroup(): DesignGroupPostElement{
    return { groupId: 0, groupName: ''};
  }

  sortCreated(sortValue: number) {
    this.sortValue = sortValue;
  }

  sortDesignGroups(designGroups: DesignGroupPostElement[]) {

  }
  getSortedDesignGroup(designGroups: DesignGroupPostElement[]) {

    designGroups.sort((a, b) => {
        return a.groupName.localeCompare(b.groupName);
    });
    return designGroups;
  }

  getSortedDesign(designs: CardWebListElement[], groupId: number) {
    const filteredDesigns = [];
    for (const design of designs) {
      if (design.groupId === undefined || design.groupId === null) {
        design.groupId = 0;
      }
      const dateTime = new Date();
      if (design.lastModifiedDateTime === undefined || design.lastModifiedDateTime === null) {
        design.lastModifiedDateTime = dateTime.toDateString();
      }
      if (design.createdDateTime === undefined || design.createdDateTime === null) {
        design.createdDateTime = dateTime.toDateString();
      }
      if (design.description === undefined || design.description === null) {
        design.description = '';
      }
      if (design.name === undefined || design.name === null) {
        design.name = this.cwrs.getDummyDesignName();
      }
      if (design.groupId === groupId) {
        filteredDesigns.push(design);
      }
    }
    filteredDesigns.sort((a, b) => {
      /*const dt1 = Date.parse(a.lastModifiedDateTime);
      const dt2 = Date.parse(b.lastModifiedDateTime);

      if (dt1 < dt2) { return 1; }
      if (dt1 > dt2) { return -1; }
      return 0;*/
      return a.name.localeCompare(b.name);
    });
    return filteredDesigns;
  }
}
